import React, { useState, useEffect } from 'react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className={`main-header main-header-two clearfix ${sticky ? 'stricky-fixed' : ''}`}>
      <div className="main-header__top">
        <div className="main-header__top-inner clearfix">
          <div className="main-header__top-left">
            <ul className="list-unstyled main-header__top-address">
              <li>
                <div className="icon">
                  <span className="icon-pin"></span>
                </div>
                <div className="text">
                  <p>A Hub for Creatives Across Africa</p>
                </div>
              </li>
              <li>
                <div className="icon">
                  <span className="icon-email"></span>
                </div>
                <div className="text">
                  <p><a href="mailto:community@c2.com">createncommune@gmail.com</a></p>
                </div>
              </li>
            </ul>
          </div>
          <div className="main-header__top-right">
            <div className="main-header__top-right-content">
              <ul className="list-unstyled main-header__top-right-menu">
                <li><a href="#vision-mission">Vision & Mission</a></li>
                <li><a href="#structure">Structure</a></li>
                <li><a href="#manifesto">Manifesto</a></li>
              </ul>
              <div className="main-header__top-right-social">
                <a href="https://x.com/CreateNCommune" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
                <a href="https://www.tiktok.com/@createncommune?is_from_webapp=1" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                <a href="https://www.instagram.com/createncommune/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav className="main-menu main-menu-two clearfix">
        <div className="main-menu__wrapper clearfix">
          <div className="main-menu__left main-menu__left--two">
            <div className="main-menu__logo">
              <a href="index.html">
                <img src={sticky ? "assets/images/c2_logo_yt.png" : "assets/images/c2_logo.png"} alt="C2 Community Logo" width="155" />
              </a>
            </div>
            <div className="main-menu__main-menu-box main-menu__main-menu-box--two">
              <a href="#!" className="mobile-nav__toggler" onClick={toggleMobileMenu}>
                <i className="fa fa-bars"></i>
              </a>
              <ul className={`main-menu__list one-page-scroll-menu ${mobileMenuOpen ? 'active' : ''}`}>
                <li className="scrollToLink current">
                  <a href="#home" onClick={() => setMobileMenuOpen(false)}>Home</a>
                </li>
                <li className="scrollToLink">
                  <a href="#about" onClick={() => setMobileMenuOpen(false)}>About Us</a>
                </li>
                <li className="scrollToLink">
                  <a href="#values" onClick={() => setMobileMenuOpen(false)}>Our Values</a>
                </li>
                <li className="scrollToLink">
                  <a href="#structure" onClick={() => setMobileMenuOpen(false)}>Structure</a>
                </li>
                <li className="scrollToLink">
                  <a href="#membership" onClick={() => setMobileMenuOpen(false)}>Membership</a>
                </li>
                <li className="scrollToLink">
                  <a href="#manifesto" onClick={() => setMobileMenuOpen(false)}>Manifesto</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="main-menu__right">
            <div className="main-menu__search-call">
              <div className="main-menu__call">
                <div className="main-menu__call-icon">
                  <img src="assets/images/icon/main-menu-icon-comment.png" alt="decorative icon" />
                </div>
                <div className="main-menu__call-number">
                  <p>Ready to Join?</p>
                  <h5><a href="mailto:createncommune@gmail.com"><span>Email Us</span></a></h5>
                </div>
              </div>
              <div className="main-menu__search-box">
                <a href="#!" className="main-menu__search search-toggler icon-magnifying-glass"><span></span></a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
